// extracted by mini-css-extract-plugin
export default {"container":"CmIngestedStyles_container__kr6J3"};